module.exports = __webpack_public_path__ + "img/pt-root-02.d24b2818.svg";